export default "__VITE_ASSET__Cpfm1C51__"